<script>
export default {
  name: "whatsapp",
};
</script>

<template>
  <div>
    <a
      href="https://api.whatsapp.com/send?phone=5519989598711&amp;"
      target="_blank"
      class="whatsapp-button"
    >
      <i class="bx bxl-whatsapp"></i>
    </a>
  </div>
</template>


<style scoped>
.whatsapp-button {
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  display: block;
  z-index: 1;
  border-radius: 50%;
}

.whatsapp-button .bx {
  font-size: 50px;
  color: var(--black);
  -webkit-backdrop-filter: blur(22px);
  backdrop-filter: blur(34px);
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 9px 2px #0e1135;
}
</style>